import { render, staticRenderFns } from "./LogoImg.vue?vue&type=template&id=e9bf0fac&scoped=true&"
import script from "./LogoImg.vue?vue&type=script&lang=js&"
export * from "./LogoImg.vue?vue&type=script&lang=js&"
import style0 from "./LogoImg.vue?vue&type=style&index=0&id=e9bf0fac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bf0fac",
  null
  
)

export default component.exports